import React, {Fragment} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import AdminDataSync from "../components/AdminDataSync";
import AdminLaneDataSearch from "../components/AdminLaneDataSearch";
import AdminExploreCity from "../components/AdminExploreCity";
import {DailyLaneDataAnalytics} from "../components/DailyLaneDataAnalytics";
import {GlobalConfig} from "../components/GlobalConfig";
import '../styles/components/administration.css';

const Administration = () => (
    <Fragment>
        <div className="administration-container">
            <Tabs defaultIndex={0}>
                <TabList className="profile-child-tabs">
                    <Tab>Global Configuration</Tab>
                    <Tab>LANE DATA PAIRS</Tab>
                    <Tab>Explore a City</Tab>
                </TabList>
                <TabPanel><GlobalConfig></GlobalConfig></TabPanel>
                <TabPanel><AdminLaneDataSearch></AdminLaneDataSearch></TabPanel>
                <TabPanel className="explore-city-panel"><AdminExploreCity></AdminExploreCity></TabPanel>
            </Tabs>
        </div>
    </Fragment>
);

export default Administration;
